import CookieConsent from "react-cookie-consent";

const CookieBanner = () => (
  <CookieConsent
    location="bottom"
    buttonText="Súhlasím"
    declineButtonText="Odmietam"
    enableDeclineButton
    containerClasses="dui-cookie-banner"
    buttonClasses="dui-cookie-banner__button"
    declineButtonClasses="dui-cookie-banner__button dui-cookie-banner__button--decline"
    contentClasses="dui-cookie-banner__content"
    expires={365}
    onAccept={() => {
      // analytics/ads/scripty povolit
    }}
    onDecline={() => {
      // analytics/ads/scripty zakazat
    }}
  >
    Táto stránka používa cookies na zlepšenie vášho zážitku. Viac informácií
    nájdete v našich&nbsp;
    <a
      href="/static/GDPR_cookies.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="dui-cookie-banner__link"
    >
      Zásadách používania cookies
    </a>
    &nbsp;
    <a
      href="/static/GDPR_cookies_CZ.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="dui-cookie-banner__link"
    >
      (CZ)
    </a>
    &nbsp;a&nbsp;
    <a
      href="/static/GDPR_doktorui.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="dui-cookie-banner__link"
    >
      Ochrane osobných údajov
    </a>
    &nbsp;
    <a
      href="/static/GDPR_doktorui_CZ.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="dui-cookie-banner__link"
    >
      (CZ)
    </a>
    .
  </CookieConsent>
);

export default CookieBanner;
